module.exports = __webpack_public_path__ + "static/img/lj2.3e7c096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj2.png
// module id = +3c0
// module chunks = 3